export const email = {
	/**
	* Gets the programmatic name of the entire locale, with the language, 
	*	country and variant separated by underbars. The Language is always lower case, 
	*	and country is always upper case. If the language is missing, 
	*	the string will begin with an underscore character. 
	*	If both the language and country fields are missing, 
	*	this function will return the empty string, 
	*	even if the variant field is filled in (you cannot have a locale with just a variant-- 
	*	the variant must accompany a valid language or country code). Examples: "en"
	*
	*/
    en: {
    	email_templates:'Email Templates',
        edit_email_templates:'Edit Email Template',
    	add_email_templates:'Add Email Template',
    	s_no:'S.No',
    	name:'Name',
    	message:'Message',
    	action:'Action',
    	template_information:'Template Information',
    	subject:'Subject',
    	body:'Body',
    	status:'Status',
    },

	ar: {
    	email_templates:'قوالب البريد الإلكتروني',
        edit_email_templates:'تحرير قالب البريد الإلكتروني',
    	add_email_templates:'أضف قالب بريد إلكتروني',
    	s_no:'لا',
    	name:'الاسم',
    	message:'الرسالة',
    	action:'العمل',
    	template_information:'معلومات النموذج',
    	subject:'الموضوع',
    	body:'الجسم',
    	status:'الحالة',
    },
}